
import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'save-view-modal',
    template: `
    <div class="w-[400px] p-5">
      <div class="flex flex-col space-y-5">
        <h2 class="font-semibold text-center">Save View</h2>
        <p class="text-center">
          Saving will override previously saved settings. <br />
          You can also create a new view.
        </p>
        <div class="flex items-center space-x-3">
          <button
            class="bv-button flex-grow text-center flex items-center justify-center"
            (click)="matDialogRef.close()"
          >
            Cancel
          </button>
          <button class="bv-submit-button flex-grow" type="submit" (click)="matDialogRef.close('update')">Save</button>
        </div>
        <button class="bv-button-link text-red-brand text-center underline" (click)="matDialogRef.close('clone')">
          Create new view
        </button>
      </div>
    </div>
  `,
    imports: []
})
export class SaveViewModal {
  matDialogRef = inject(MatDialogRef)
}
